(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcc-shipping-story"] && !Shopify.designMode) return;
  try {
    function initializeRccShipping(scope) {
  scope.querySelectorAll('[data-rcc-shipping-story]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const data = JSON.parse(root.querySelector('.rcc-destination-data').textContent);
    const detail = root.querySelector('.rcc-detail');
    const select = root.querySelector('.rcc-region-select');
    const regions = [...root.querySelectorAll('.rcc-region')];
    regions.forEach(region => {
      region.dataset.label = region.dataset.label.replace('United States of America:', 'United States:');
      if (region.dataset.label === 'Georgia: 0 distinct destinations') region.dataset.label = 'Georgia (country): 0 distinct destinations';
    });
    const maps = [...root.querySelectorAll('.rcc-map')];
    const names = [...new Set(regions.map(region => region.dataset.label.split(':')[0]))].sort();
    names.forEach(name => { const option = document.createElement('option'); option.value = name; option.textContent = name; select.append(option); });
    const views = maps.map(map => {
      const svg = map.querySelector('svg');
      svg.setAttribute('role', 'group');
      const base = svg.getAttribute('viewBox').split(' ').map(Number);
      let box = [...base];
      const draw = () => { svg.setAttribute('viewBox', box.join(' ')); svg.style.touchAction = box[2] < base[2] ? 'none' : 'auto'; };
      const zoom = factor => {
        const width = Math.max(base[2] / 8, Math.min(base[2], box[2] * factor));
        const height = width * base[3] / base[2];
        box = [box[0] + (box[2] - width) / 2, box[1] + (box[3] - height) / 2, width, height]; draw();
      };
      const toolbar = document.createElement('div'); toolbar.className = 'rcc-map-controls';
      [['Zoom in', '+', () => zoom(.7)], ['Zoom out', '−', () => zoom(1/.7)], ['Reset map', 'Reset', () => { box = [...base]; draw(); }]].forEach(([label, text, action]) => {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = text; button.setAttribute('aria-label', label); button.addEventListener('click', action); toolbar.append(button);
      });
      map.before(toolbar);
      let drag = null; let moved = false;
      svg.addEventListener('pointerdown', event => {
        if (event.button !== 0 || box[2] >= base[2]) return;
        drag = { x:event.clientX, y:event.clientY, box:[...box], id:event.pointerId }; moved = false;
        svg.setPointerCapture(event.pointerId);
      });
      svg.addEventListener('pointermove', event => {
        if (!drag) return;
        const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
        if (Math.abs(dx) + Math.abs(dy) > 5) moved = true;
        const rect = svg.getBoundingClientRect();
        box = [drag.box[0]-dx/rect.width*drag.box[2], drag.box[1]-dy/rect.height*drag.box[3],box[2],box[3]]; draw();
      });
      const release = () => { drag = null; };
      svg.addEventListener('pointerup', release); svg.addEventListener('pointercancel', release);
      svg.addEventListener('click', event => { if(moved) { event.stopPropagation(); moved = false; } }, true);
      return { svg, focus(region) {
        const bounds = region.getBBox(); const ratio = base[2]/base[3];
        const width = Math.min(base[2],Math.max(bounds.width*1.8,bounds.height*1.8*ratio,base[2]/8));
        box = [bounds.x+bounds.width/2-width/2,bounds.y+bounds.height/2-width/ratio/2,width,width/ratio]; draw();
      }};
    });
    function show(name, focus = false) {
      select.value = names.includes(name) ? name : '';
      regions.forEach(region => region.classList.toggle('rcc-selected',region.dataset.label.split(':')[0]===name));
      detail.replaceChildren();
      const heading = document.createElement('h3'); heading.textContent = name; detail.append(heading);
      const matching = regions.find(region => region.dataset.label.split(':')[0]===name);
      const count = matching ? Number(matching.dataset.label.match(/: (\d+)/)[1]) : data[name]?.count || 0;
      const description = document.createElement('p');
      description.textContent = count ? `Our creations have reached ${count.toLocaleString()} recorded city/postal ${count === 1 ? 'destination' : 'destinations'} here.` : 'A future crafty destination — we’d love to send something here!'; detail.append(description);
      const cities = data[name]?.cities || [];
      if(cities.length) {
        const summary = document.createElement('p'); summary.textContent = 'Places we’ve shipped to'; detail.append(summary);
        const list = document.createElement('ul'); list.className='rcc-city-list';
        cities.forEach(city=> { const item=document.createElement('li');item.textContent=city;list.append(item); }); detail.append(list);
      }
      if(focus && matching) views.find(view=>view.svg.contains(matching))?.focus(matching);
    }
    regions.forEach(region => {
      region.addEventListener('click', () => show(region.dataset.label.split(':')[0]));
    });
    select.addEventListener('change', () => { if(select.value) show(select.value,true); });
    root.querySelectorAll('.rcc-country-button').forEach(button=>button.addEventListener('click',()=>show(button.textContent,true)));
  });
}
initializeRccShipping(document);
document.addEventListener('shopify:section:load', () => initializeRccShipping(document));


  } catch(e) { console.error(e); }
})();
})();
